export default "__VITE_ASSET__c7b178dd__"